/*
usage:

import {confirm, alert} from '@/utils/modal'
modal(title, subtitle, actions).then((value) => {
});
confirm(...).then((yes) => {})
alert(...).then(() => {})

var actions = [
  {
    color: 'primary',
    value: 'result value',
    text: 'text of action',
    // close the modal on click?
    close: false,
  },
];
*/
import store from '@/store';
import { HIDE_MODAL, SHOW_MODAL } from '@/config/constants';

export function modal(title: string, subtitle: string, actions: any) {
  var modal = { title, subtitle, actions };
  return new Promise(function(resolve, reject) {
    store.commit(SHOW_MODAL, modal);
    var unwatch = store.watch(
      (state: any) => state.navigation.modal.result,
      result => {
        unwatch();
        // default: close modal
        if (result && result.close !== false) {
          store.commit(HIDE_MODAL);
        }
        resolve(result ? result.value : null);
      }
    );
  });
}

export function confirm(title: string, subtitle: string, ok_text: string, abort_text: string) {
  return modal(title, subtitle, [
    {
      color: 'secondary',
      value: 'abort',
      text: abort_text ? abort_text : 'Cancel'
    },
    {
      color: 'primary',
      value: 'confirm',
      text: ok_text ? ok_text : 'Yes'
    }
  ]).then(result => {
    return result && result === 'confirm';
  });
}

export function alert(title: string, subtitle: string, ok_text: string) {
  return modal(title, subtitle, [
    {
      color: 'primary',
      value: 'ok',
      text: ok_text ? ok_text : 'Ok'
    }
  ]).then(result => {
    // no value
    return;
  });
}
